var React = require('react');

function LogoDekode (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Dekode, WordPress VIP agency"),React.createElement("path",{"d":"M17.8 15.9L-8.5.1c-.2-.1-.4 0-.4.2v35.6c0 .2.2.3.4.2l4.9-3c.2-.1.4-.4.4-.7V10.1c0-.2.2-.3.4-.2 0 0 17.4 10.5 17.9 10.7 6.1 3.8 6.2 10.9 3.9 14.8-.1.1 0 .2.2.1 6.2-3.8 9.7-12.7-1.4-19.6z","key":1}),React.createElement("path",{"d":"M9.3 27.6c-.1-.2-.5-.2-.5-.2L-9.8 38.6c-.4.2-.6.1-.6-.1V.3c0-.2-.2-.3-.4-.2L-15.6 3c-.2.1-.4.4-.4.6V48c0 .2.2.3.4.2l23-13.5c3.2-1.8 4.5-4.4 1.9-7.1z","key":2}),React.createElement("path",{"d":"M13.8 21.6l-15.1-9.1c-.2-.1-.4 0-.4.2v5.5c0 .2.2.6.4.7l9.8 5.9c4.5 2.9 5.9 7.5-.2 11.1l-23.1 13.6c-.2.1-.2.3 0 .5l4.9 2.9c.2.1.6.1.8 0l23.5-14.3c6.1-3.7 5.7-13-.6-17z","key":3})]);
}

LogoDekode.defaultProps = {"viewBox":"-16 0 41 53"};

module.exports = LogoDekode;

LogoDekode.default = LogoDekode;
